<script>
export default {
  name: 'UlCardFooter',
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'ul-card-footer--border': this.border,
        'ul-card-footer--sticky': this.sticky,
      };
    },
  },
};
</script>
<template>
  <div class="ul-card-footer" :class="classes">
    <slot></slot>
  </div>
</template>
<style lang="scss">
  .ul-card-footer {
    position: relative;
    padding: 24px;
    text-align: right;
    background: #ffffff;
    margin: 0 -24px -24px -24px;

    &--border {
      margin-top: 24px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 1px;
        background: #999999;
      }
    }

    &--sticky {
      position: sticky;
      bottom: 0;
      z-index: 10;
    }
  }
</style>
